/**
* p05001固有メッセージ
*/

export const map = new Map([

/* Product information */
['product.name.05.001','キニッタ！グルメ'], 
/* メールタイトル */
['product.name.05.001.title.mail','キニッタ！グルメ'],

/* メッセージ */
['msg.05001003','店舗が選択されてません。'],
['msg.05001004','写真が選択されてません。'],
['msg.05001005','写真は存在しません。'],
['msg.05001006','お探しのお店は見つかりませんでした。'],
['msg.05001007','仮登録中店舗のため只今会員登録は受け付けておりません。'],
['msg.05001008','入力された数字が正しくありません。'],
['msg.05001009','利用可能ポイントが不足しています。'],

/* 画面ラベル */
['screen.s05001000.usePnts','利用ポイント'],
['screen.s05001000.availablePntBlnc','利用可能ポイント'],
['screen.s05001000.availableLmtdPntBlnc','うち期間限定ポイント'],

/* ページタイトル */
['screen.s05001000.title','ログイン'],
['screen.s05001001.title','飲食店検索'],
['screen.s05001002.title','飲食店登録/更新'],
['screen.s05001003.title','お店ホームページ'],
['screen.s05001004.title','感染対策状況の評価'],
['screen.s05001005.title','デイリーカレンダー'],
['screen.s05001006.title','お気に入り'],
['screen.s05001007.title','会員登録'],
['screen.s05001008.title','イベント詳細表示'],
['screen.s05001009.title','本登録について'],
['screen.s05001010.title','投稿、掲載内容の通報'],
['screen.s05001011.title','アップロード写真'],
['screen.s05001012.title','会員登録済み店舗'],
['screen.s05001013.title','キニッタ！グルメ インストール方法'],
['screen.s05001014.title','ポイント利用'],
['screen.s05001015.title','ポイント利用確認'],
['screen.s05001016.title','ポイント利用履歴'],

/* チャット */
['screen.s05001003.label.shop','お店'],
['screen.s05001003.label.customer','あなた'],
['screen.s05001003.label.noData','表示データはありません。'],
['screen.s05001003.label.deleted','に削除されました。'],

]);